'use strict';
define(['xhr-promise'], function (XhrPromise) {

    var changeListeners  = [];

    /**
     * Add basket update callbacks
     * @param {Function} callback Callback method
     */
    function onChange(callback) {
        changeListeners.push(callback);
    }

    /**
     * Initiate request to load basket detail
     */
    function load(miniBagCMD, requestParams) {
        var xhrp = new XhrPromise();
        return xhrp.send({
            url: miniBagCMD,
            method: 'POST',
            body: Object.assign({resJSON: true}, {
                requestParams: requestParams
            })
        }).then(function(response) {
            if (response.status === 200) {
                update(response.responseText);
            }
        }).catch(function(){
            //Handle errors here
        });
    }

    function removeItem(removeUrl) {
        var xhrp = new XhrPromise();
        return xhrp.send({
            url: removeUrl,
            method: 'POST'
        }).then(function () {

        }).catch(function () {
            //Handle errors here
        });
    }

    /**
     * Execute basket update callback list
     * @param {Object} data Basket details
     */
    function update(data) {
        changeListeners.map(function(callback) {
            callback(data);
        });
    }

    // service API
    return {
        load: load,
        onChange: onChange,
        removeItem: removeItem
    };
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/miniBag/service.js